<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/zpjPqn/tc-custom/9780226048420.jpg?1722581149067" alt="This image is the cover for the book Wartime President"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Wartime President
      </h1>
      <p class="bookDescription body article font2">
        <p>“It is the nature of war to increase the executive at the expense of the legislative authority,” wrote Alexander Hamilton in the Federalist Papers. The balance of power between Congress and the president has been a powerful thread throughout American political thought since the time of the Founding Fathers. And yet, for all that has been written on the topic, we still lack a solid empirical or theoretical justification for Hamilton’s proposition.           <br/> For the first time, William G. Howell, Saul P. Jackman, and Jon C. Rogowski systematically analyze the question. Congress, they show, is more likely to defer to the president’s policy preferences when political debates center on national rather than local considerations. Thus, World War II and the post-9/11 wars in Afghanistan and Iraq significantly augmented presidential power, allowing the president to enact foreign and domestic policies that would have been unattainable in times of peace. But, contrary to popular belief, there are also times when war has little effect on a president’s influence in Congress. The Vietnam and Gulf Wars, for instance, did not nationalize our politics nearly so much, and presidential influence expanded only moderately.           <br/> Built on groundbreaking research, <i>The Wartime President</i> offers one of the most significant works ever written on the wartime powers presidents wield at home.<br/></p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        William G. Howell, Saul P. Jackman, Jon C. Rogowski
      </h2>
      
      <p class="authorDescription body article"><B>William G. Howell</B> is the Sydney Stein Professor in American Politics at the Harris School of Public Policy Studies and professor of political science in the College at the University of Chicago. He is the author or coauthor of several books, including, most recently, <I>Thinking about the Presidency: The Primacy of Power</I> and <I>While Dangers Gather: Congressional Checks on Presidential War Powers.</I><B>Saul P. Jackman</B> is a fellow at the Brookings Institution in Washington, DC. <B>Jon C. Rogowski</B> is assistant professor in the Department of Political Science at Washington University in St. Louis.<br></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      The University of Chicago Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?5ad179fc